import Image from "next/image"
import { usePathname, useSearchParams } from "next/navigation"
import { Button } from "@ui/shad"

import { useGetAuthUriMutation } from "@/hooks/api/email_integrations"
import { EmailMessageBackground } from "@/components/integrations"
import { useEmailConnectNotice } from "@/components/integrations/email-connect-notice"

export default function EmailDialog() {
  const authMutation = useGetAuthUriMutation()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  async function handleProviderConnect(provider: string) {
    const returnParams = new URLSearchParams(searchParams.toString())
    returnParams.set("email", "connected")
    const { auth_uri } = await authMutation.mutateAsync({
      provider,
      returnTo: `${pathname}?${returnParams.toString()}`,
      source: "client",
    })
    window.location.href = auth_uri
  }

  const { requestConnect, noticeDialog } = useEmailConnectNotice(handleProviderConnect)

  return (
    <>
      <div className="h-full w-full" style={{ filter: "blur(6px)" }}>
        <EmailMessageBackground />
      </div>
      <div className="bg-background absolute top-0 left-0 z-2 flex h-full w-full opacity-80" />
      <div className="absolute top-0 left-0 z-3 flex h-full w-full flex-col items-center justify-center p-4">
        <span className="text-2xl font-semibold">Connect your email</span>
        <span className="text-muted-foreground text-sm">Choose one of the providers below to get started.</span>
        <div className="mt-4 flex items-center gap-2">
          <Button variant="outline" onClick={() => requestConnect("google")}>
            <Image src="/google.svg" alt="Google" width={16} height={16} />
            Google
          </Button>
          <Button variant="outline" onClick={() => requestConnect("microsoft")}>
            <Image src="/outlook.svg" alt="Outlook" width={16} height={16} />
            Outlook
          </Button>
        </div>
      </div>
      {noticeDialog}
    </>
  )
}
